module.exports = __webpack_public_path__ + "static/media/colheitadeira2.f696e10e.svg";